<template>
  <v-row align="center" justify="center">
    <div class="text-h4 white--text">404. That's an error.</div>
  </v-row>
</template>

<script>
export default {
  name: 'Error',

  data: () => ({
    //
  }),
};
</script>
